import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Radio } from "lucide-react";
import { useSettings } from "../lib/useSettings";

export default function LiveTV() {
  const { settings } = useSettings();
  const live = settings.live || {};
  const ytId = live.youtube_live_video_id || live.youtube_channel_id;
  const enabled = !!live.enabled && !!ytId;
  const embedSrc = live.youtube_live_video_id
    ? `https://www.youtube.com/embed/${live.youtube_live_video_id}?autoplay=0&rel=0`
    : live.youtube_channel_id
    ? `https://www.youtube.com/embed/live_stream?channel=${live.youtube_channel_id}&autoplay=0`
    : null;

  return (
    <section className="my-16" data-testid="livetv-section">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-zinc-950 via-zinc-900 to-black p-8 sm:p-12">
        <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bodh-gradient opacity-40 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bodh-gradient opacity-30 blur-3xl" />
        <div className="relative grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 bg-[#E30613]/15 border border-[#E30613]/40 text-[#FF5A66] text-[11px] font-outfit font-black uppercase tracking-widest px-3 py-1 rounded-full">
              <span className="h-2 w-2 rounded-full bg-[#E30613] bodh-pulse" /> Live
            </div>
            <h2 className="mt-4 font-devanagari font-black text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              अभी देखिए <span className="bodh-text-gradient">Bodh Live</span> — हर मिनट की खबर
            </h2>
            <p className="mt-4 text-zinc-300 max-w-xl font-devanagari">
              हमारी 24x7 लाइव स्ट्रीम पर देखिए देश-विदेश की हर बडी खबर सीधे न्यूजरूम से.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/live" data-testid="livetv-watch" className="inline-flex items-center gap-2 bg-white text-zinc-900 px-5 py-2.5 rounded-full font-outfit font-bold text-sm hover:bg-yellow-300 transition">
                <Radio className="h-4 w-4 text-[#E30613]" /> लाइव देखें <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/category/video" data-testid="livetv-more" className="inline-flex items-center gap-2 border border-white/30 text-white px-5 py-2.5 rounded-full font-outfit font-bold text-sm hover:bg-white/10 transition">
                वीडियो न्यूज
              </Link>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="relative aspect-video rounded-2xl overflow-hidden border border-white/10 bg-zinc-800/60 backdrop-blur-md">
              {enabled && embedSrc ? (
                <iframe
                  src={embedSrc}
                  title="Bodh Live"
                  data-testid="livetv-iframe"
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <>
                  <img src="https://images.unsplash.com/photo-1495020689067-958852a7765e?crop=entropy&cs=srgb&fm=jpg&q=85" alt="live" className="absolute inset-0 w-full h-full object-cover opacity-60" />
                  <div className="absolute inset-0 bg-black/40" />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-[#E30613] text-white text-[10px] font-outfit font-black uppercase tracking-widest flex items-center gap-1.5">
                    <span className="h-1.5 w-1.5 rounded-full bg-white bodh-pulse" /> LIVE
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="h-20 w-20 rounded-full bodh-gradient flex items-center justify-center shadow-2xl">
                      <Radio className="h-9 w-9 text-white" />
                    </div>
                  </div>
                  <div className="absolute bottom-3 left-3 right-3 text-white font-devanagari font-bold">
                    Bodh Live • Admin से YouTube Live ID सेट करें
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
